<template>
    <div class="wrapper">
        <div class="txt">主公，請先登入遊戲，即可查看更多遊戲資訊喔！</div>
        <loading v-show="isLoading"></loading>
    </div>
</template>

<script>
import Loading from './Loading'
import HomeSwiper from '@/components/HomeSwiper.vue'
import HomeNav from '@/components/HomeNav.vue'
import HomePost from '@/components/HomePost.vue'
import HomeBot from '@/components/HomeBot.vue'

export default {
    name: '',
    data() {
        return {
            isLoading:false
        }
    },
    components: {
        Loading
    },
    methods:{

    },
    created() {
        this.isLoading = true;
    },
    mounted() {
        this.isLoading = false;
    }
}
</script>

<style lang="stylus" scoped>
.wrapper
    max-width 750px
    margin 0 auto
    position relative
    .txt
        position: absolute;
        font-size: 0.295rem;
        text-align: center;
        width: 30vw;
        height: 10vh;
        left: 50%;
        top: 50%;
        margin-left: -15vw;
        margin-top: 42vh;
        line-height: 6vh;
        z-index: 999999999;
</style>
